import { createSlice } from "@reduxjs/toolkit";

const initialAddGameTypeState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: [],
  exportData: [],
  newGameType: {},
  uploadimage: [],
  featuredImage: {},
  gameForEdit: {},
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const AddGameTypeSlice = createSlice({

  name: "addGameType",
  initialState: initialAddGameTypeState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    uploadImage: (state, action) => {
      const { uploadimage, imageField } = action.payload;
      console.log('uploadimage',uploadimage)
      state.error = null;
      state.uploadimage = uploadimage;
      state.featuredImage = uploadimage;
      //state.imageField = imageField;
    },
    clearfetchStaffUsers: (state, action) => {
      state.listLoading = false;
      state.error = null;
      state.entities = [];
      state.totalCount = 0;
    },
    emptyList: (state, action) => {
      state.error = null;
      state.entities = [];
      // state.totalCount = 0;
      state.exportData = [];
    },
    createGameType: (state, action) => {
      const { newGameType } = action.payload;
      state.error = null;
      state.newGameType = newGameType;
    },
    singleItemFetched: (state, action) => {
      const { gameForEdit } = action.payload;
      state.gameForEdit = gameForEdit;
      state.error = null;
    },
  }
});
